export default __webpack_public_path__ + "static/media/api-credential-white.8cc37f49.svg";